import constants from '../qti/Constants';
import sessionReader from '../store/readHelpers/SessionReader';
import sessionCache from './SessionCache';
import stateCacheService from './StateCache';

const PLAYING_MULTIMEDIA_CURRENT_TIME = 'PLAYING_MULTIMEDIA_CURRENT_TIME';

const multimediaService = {
    getStorageKey({ questionId, logicalName }, assessmentRunId, userId) {
        return `${assessmentRunId}_${userId}_${questionId}_${logicalName}`;
    },

    getResumeMultimediaKey(multimediaModel) {
        const assessmentRunId = sessionReader.getAssessmentRunId();
        const userId = sessionReader.getUserId();
        return `${this.getStorageKey(multimediaModel, assessmentRunId, userId)}/${PLAYING_MULTIMEDIA_CURRENT_TIME}`;
    },

    getStoredPlayCount(multimediaModel) {
        const stateCache = stateCacheService.getStateCacheInstance();
        const assessmentRunId = sessionReader.getAssessmentRunId();
        const userId = sessionReader.getUserId();
        const storageKey = this.getStorageKey(multimediaModel, assessmentRunId, userId);

        const storedPlayCount = sessionReader.isContextReadinessCheck()
            ? parseInt(sessionCache.getItem(storageKey), 10)
            : parseInt(stateCache.getQuestionCacheValue(storageKey), 10);

        return isNaN(storedPlayCount) ? 0 : storedPlayCount;
    },

    /**
     * Checks that media has been started playing at least once
     */
    isMediaPlayed(multimediaModel) {
        return this.getStoredPlayCount(multimediaModel) > 0;
    },

    canPlayOnlyOnce(multimediaModel) {
        return multimediaModel?.repeatTimes === 0;
    },

    updateTimesPlayed(multimediaModel, incrementStorageValue = false) {
        const stateCache = stateCacheService.getStateCacheInstance();
        const assessmentRunId = sessionReader.getAssessmentRunId();
        const userId = sessionReader.getUserId();
        const storageKey = this.getStorageKey(multimediaModel, assessmentRunId, userId);
        let timesPlayed = this.getStoredPlayCount(multimediaModel);

        if (incrementStorageValue) {
            if (sessionReader.isContextReadinessCheck()) {
                sessionCache.setItem(storageKey, (++timesPlayed).toString());
            } else {
                stateCache.setQuestionCacheValue(storageKey, ++timesPlayed);
            }
        }

        return timesPlayed;
    },

    isVideoType(multimediaModel) {
        return multimediaModel?.type === constants.mediaType.VIDEO;
    },
};

export default multimediaService;
